import { render, staticRenderFns } from "./GridSwitch.vue?vue&type=template&id=a2927ea0&"
import script from "./GridSwitch.vue?vue&type=script&lang=js&"
export * from "./GridSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports